// extracted by mini-css-extract-plugin
export var black = "_2h-6";
export var brand = "_2h-1";
export var ddefault = "_2h-0";
export var error = "_2h-3";
export var gray = "_2h-2";
export var highContrast = "_2h-8";
export var outline = "_2h-7";
export var success = "_2h-5";
export var warning = "_2h-4";